/* eslint-disable react/no-unknown-property */
import React from 'react';

/**
 * Configura o VLibras para a aplicacao.
 * @returns Componente React que configura o VLIBRAS.
 */
export const VLibras = () => {
  return (
    <div vw='true' className='enabled'>
      <div vw-access-button='true' className='active'></div>
      <div vw-plugin-wrapper='true'>
        <div className='vw-plugin-top-wrapper'></div>
      </div>
    </div>
  );
};
